// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"40":"095da1325451a776","188":"cc62fb89d5b48301","596":"20291a61f15cbf17","680":"432366316bc06b5e","729":"9d6dd478af9cc710","869":"dfb19b6992ebbdc7","885":"c9fecde1ea41962d","965":"4fff1e5d2984af72","997":"3835ed32ee6c25b3"}[chunkId] + ".js";
};